module.exports = __webpack_public_path__ + "media/images/global/header-logo-no-brown-043b5f165d18f4fca54059b7ae2542f2.png";